import { LogLevelFilter } from 'kv-logger';
import { LogCategoryFilter } from './logCategoryFilter';
export function withFilter(options) {
    return (transport) => {
        let result = transport;
        if (options.category) {
            result = new LogCategoryFilter(result, options.category);
        }
        if (options.level && options.level !== 'debug') {
            result = new LogLevelFilter(result, options.level);
        }
        return result;
    };
}
